export enum UserModuleAnswerType {
	TASK = 'TASK',
	QUESTION = 'QUESTION',
	DOCUMENT = 'DOCUMENT',
	ARTICLE = 'ARTICLE',
}
